// extracted by mini-css-extract-plugin
export default {"gridContainer":"ImageGrid_gridContainer__zQUy2","image":"ImageGrid_image__KQOBt"};